import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiRocket, FiTrendingUp, FiUsers, FiDollarSign } = FiIcons;

const Hero = () => {
  return (
    <section id="home" className="pt-20 pb-16 px-4 overflow-hidden">
      <div className="container mx-auto">
        <div className="text-center max-w-4xl mx-auto">
          {/* Hero Badge */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center space-x-2 bg-pink-100 text-pink-700 px-4 py-2 rounded-full text-sm font-medium mb-6"
          >
            <SafeIcon icon={FiTrendingUp} className="animate-bounce" />
            <span>🚀 Now Live on Pump.fun</span>
          </motion.div>

          {/* Main Heading */}
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight"
          >
            <span className="bg-gradient-to-r from-pink-600 via-purple-600 to-pink-500 bg-clip-text text-transparent">
              PinkZilla
            </span>
            <br />
            <span className="text-gray-800">The Meme Coin</span>
            <br />
            <span className="text-gray-600 text-3xl md:text-4xl lg:text-5xl">
              That's Going Viral
            </span>
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto leading-relaxed"
          >
            Join the unstoppable force that's taking the crypto world by storm. 
            PinkZilla isn't just a meme coin - it's a movement, a community, and your ticket to the moon! 🌙
          </motion.p>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="flex flex-col sm:flex-row gap-4 justify-center mb-12"
          >
            <motion.a
              href="https://pump.fun/AV1AQPodLxw43q7qB7c8HXHx6NrMSGi9z3tb4U7ypump"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-gradient-to-r from-pink-500 to-purple-600 text-white px-8 py-4 rounded-full font-bold text-lg shadow-2xl hover:shadow-pink-500/25 transition-all flex items-center justify-center space-x-2"
            >
              <SafeIcon icon={FiRocket} className="animate-bounce" />
              <span>Buy $PINKZILLA Now</span>
            </motion.a>
            
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="border-2 border-pink-500 text-pink-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-pink-50 transition-all flex items-center justify-center space-x-2"
              onClick={() => document.getElementById('features').scrollIntoView({ behavior: 'smooth' })}
            >
              <SafeIcon icon={FiUsers} />
              <span>Learn More</span>
            </motion.button>
          </motion.div>

          {/* Stats */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-2xl mx-auto"
          >
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-pink-600">1M+</div>
              <div className="text-sm text-gray-600">Holders</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-purple-600">500%</div>
              <div className="text-sm text-gray-600">Growth</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-pink-600">24/7</div>
              <div className="text-sm text-gray-600">Trading</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-purple-600">100K+</div>
              <div className="text-sm text-gray-600">Community</div>
            </div>
          </motion.div>
        </div>

        {/* Hero Image */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.8 }}
          className="mt-16 flex justify-center"
        >
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=600&h=400&fit=crop"
              alt="PinkZilla Meme Coin"
              className="rounded-3xl shadow-2xl animate-float"
            />
            <div className="absolute -top-4 -right-4 bg-gradient-to-r from-pink-500 to-purple-600 text-white px-4 py-2 rounded-full font-bold animate-pulse">
              🔥 HOT
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;